<template>
    <div class="bgViewStyle">
        <van-nav-bar
            left-arrow
            fixed
            placeholder
            safe-area-inset-top
            @click-left="goBack"
        />

        <div class="decor decor-top"></div>
        <div class="decor decor-right"></div>

        <div class="page-content">
            <!-- 品牌 -->
            <div class="brand">
                <img class="brand-logo" src="@/assets/logo.png" alt="东朔空间" />
                <div class="brand-text">
                    <div class="brand-name">东朔空间</div>
                    <div class="brand-slogan">让 办 公 更 美 好</div>
                </div>
            </div>

            <!-- 主标题 -->
            <h1 class="hero-title">
                离你更近，<br />会议更轻松
            </h1>

            <!-- 登录卡片 -->
            <div class="login-card">
                <div class="card-header">
                    <div class="card-icon">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="7" y="2.5" width="10" height="19" rx="2.2" stroke="#2B7DE9" stroke-width="1.6"/>
                            <path d="M10.5 5.5h3" stroke="#2B7DE9" stroke-width="1.6" stroke-linecap="round"/>
                            <circle cx="12" cy="17.5" r="1.1" fill="#2B7DE9"/>
                        </svg>
                    </div>
                    <div class="card-header-text">
                        <div class="card-title">注册登录</div>
                        <div class="card-subtitle">验证手机号后即可预约会议室</div>
                    </div>
                </div>

                <div class="form-item">
                    <label class="form-label">手机号</label>
                    <input
                        class="form-input"
                        type="tel"
                        maxlength="11"
                        placeholder="请输入手机号"
                        v-model="phone"
                    />
                </div>

                <div class="form-item">
                    <label class="form-label">验证码</label>
                    <div class="code-row">
                        <input
                            class="form-input code-input"
                            type="tel"
                            maxlength="6"
                            placeholder="请输入验证码"
                            v-model="code"
                        />
                        <button
                            class="code-btn"
                            type="button"
                            :disabled="countdown > 0 || !isPhoneValid"
                            @click="handleGetCode"
                        >
                            {{ countdown > 0 ? `${countdown}s` : '获取验证码' }}
                        </button>
                    </div>
                </div>

                <div class="agree-row" @click="onAgreeRowClick">
                    <span class="agree-checkbox" :class="{ checked: agreed }">
                        <svg v-if="agreed" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 5l3.2 3.2L11 1.5" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <span class="agree-text">
                        我已阅读并同意
                        <a href="javascript:;" @click.stop="openAgreement('user')">《用户服务协议》</a>
                        和
                        <a href="javascript:;" @click.stop="openAgreement('privacy')">《隐私政策》</a>
                    </span>
                </div>

                <button
                    class="login-btn"
                    type="button"
                    :disabled="!canLogin"
                    @click="handleLogin"
                >
                    登录
                </button>
            </div>

            <p class="footer-tip" v-show="isShowText">登录后可自动保持登录状态</p>
        </div>
    </div>
</template>

<script>
    import MonitorKeyboard from '../../tools/MonitorKeyboard.js'
    import { setRegisterLoginRequest, getRegisterLoginSmsCodeRequest } from '../../request/api';
    import { parseIsAdmin, parseIsSuperAdmin, notifyUserInfoUpdated } from '../../tools/utils';
    import { Toast } from 'vant';

    export default {
        name: 'login',
        props: {
            msg: String
        },
        data() {
            return {
                title: '登录',
                monitorKeyboard: null,
                phone: '',
                code: '',
                agreed: false,
                countdown: 0,
                timer: null,
                isShowText: true,
            };
        },

        computed: {
            isPhoneValid() {
                return /^1\d{10}$/.test(this.phone);
            },
            canLogin() {
                return this.isPhoneValid && this.code.length >= 4 && this.agreed;
            },
        },

        mounted() {
            this.getKeyboardState();
        },

        beforeRouteLeave(to, from, next) {
            if (to.name === 'userAgreement' || to.name === 'privacyPolicy') {
                this._preserveLoginForm = true;
                this.saveLoginFormSnapshot();
            }
            next();
        },

        activated() {
            if (this._preserveLoginForm) {
                this._preserveLoginForm = false;
                this.restoreLoginFormSnapshot();
                return;
            }
            this.resetLoginForm();
        },

        beforeDestroy() {
            if (this.monitorKeyboard) {
                this.monitorKeyboard.onEnd();
            }
            if (this.timer) {
                clearInterval(this.timer);
            }
        },

        methods: {
            resetLoginForm() {
                this.phone = '';
                this.code = '';
                this.agreed = false;
                if (this.timer) {
                    clearInterval(this.timer);
                    this.timer = null;
                }
                this.countdown = 0;
            },

            saveLoginFormSnapshot() {
                this._loginFormSnapshot = {
                    phone: this.phone,
                    code: this.code,
                    agreed: this.agreed,
                    countdown: this.countdown,
                };
            },

            restoreLoginFormSnapshot() {
                const snap = this._loginFormSnapshot;
                this._loginFormSnapshot = null;
                if (!snap) return;
                this.phone = snap.phone;
                this.code = snap.code;
                this.agreed = snap.agreed;
                this.countdown = snap.countdown;
            },

            onAgreeRowClick(e) {
                if (e.target.closest('a')) {
                    return;
                }
                this.agreed = !this.agreed;
            },

            goBack() {
                if (window.history.length > 1) {
                    this.$router.back()
                } else {
                    this.$router.replace('/home')
                }
            },

            getKeyboardState(){
                this.monitorKeyboard = new MonitorKeyboard();
                this.monitorKeyboard.onStart();

                this.monitorKeyboard.onShow(() => {
                    this.isShowText = false;
                })

                this.monitorKeyboard.onHidden(() => {
                    this.isShowText = true;
                })
            },

            handleGetCode() {
                if (this.phone.length == 0) {
                    this.$toast && this.$toast('请输入手机号');
                }
                if (!this.isPhoneValid) {
                    this.$toast && this.$toast('请输入正确的手机号');
                    return;
                }
                if (this.countdown > 0) {
                    return;
                }
                let param = {
                    phone: this.phone,
                }
                Toast.loading({
                    message: '正在获取验证码',
                    forbidClick: true,
                    duration: 0, // 不自动关闭，需手动 clear
                });
                getRegisterLoginSmsCodeRequest(param).then(res => {
                    console.log('获取验证码成功--->', res);
                    this.countdown = 60;
                    this.timer = setInterval(() => {
                        if (this.countdown <= 1) {
                            clearInterval(this.timer);
                            this.timer = null;
                            this.countdown = 0;
                        } else {
                            this.countdown -= 1;
                        }
                    }, 1000);
                    this.$toast && this.$toast('验证码已发送');
                }).catch(err => {
                    this.$toast && this.$toast('验证码发送失败');
                }).finally(() => {
                    Toast.clear();
                });
            },

            openAgreement(type) {
                this._preserveLoginForm = true;
                this.saveLoginFormSnapshot();
                if (type === 'user') {
                    this.$router.push({ name: 'userAgreement' });
                } else if (type === 'privacy') {
                    this.$router.push({ name: 'privacyPolicy' });
                }
            },

            handleLogin() {
                if (!this.canLogin) return;
                let param = {
                    phone: this.phone,
                    verificationCode: this.code,
                }
                Toast.loading({
                    message: '登录中...',
                    forbidClick: true,
                    duration: 0, // 不自动关闭，需手动 clear
                });
                setRegisterLoginRequest(param).then(res => {
                    console.log('登录成功--->', res);
                    const payload = (res && res.data) || {};
                    const user = payload.user || {};
                    const isAdmin = parseIsAdmin(user.isAdmin);
                    const isSuperAdmin = parseIsSuperAdmin(user.isSuperAdmin);
                    console.log('登录成功 isAdmin--->', isAdmin);
                    console.log('登录成功 isSuperAdmin--->', isSuperAdmin);
                    this.$toast && this.$toast('登录成功');
                    const userInfo = {
                        isAdmin,
                        isSuperAdmin,
                        token: payload.token,
                        phone: this.phone,
                        loginTime: Date.now(),
                    };
                    localStorage.setItem('userInfo', JSON.stringify(userInfo));
                    notifyUserInfoUpdated();
                    this.$router.replace('/home');
                }).catch(err => {
                    this.$toast && this.$toast('登录失败');
                }).finally(() => {
                    Toast.clear();
                });
            }
        }
    }
</script>

<style scoped>
.bgViewStyle {
    position: relative;
    width: 100%;
    min-height: 100vh;
    overflow: hidden;
    background: linear-gradient(165deg, #eef5ff 0%, #f5f8fc 42%, #ffffff 100%);
    box-sizing: border-box;
}

.decor {
    position: absolute;
    border-radius: 50%;
    pointer-events: none;
}

.decor-top {
    top: -1.2rem;
    left: -0.8rem;
    width: 3.6rem;
    height: 3.6rem;
    background: radial-gradient(circle, rgba(190, 220, 255, 0.55) 0%, rgba(190, 220, 255, 0) 70%);
}

.decor-right {
    top: 0.6rem;
    right: -1.4rem;
    width: 4.2rem;
    height: 4.2rem;
    background: radial-gradient(circle, rgba(200, 226, 255, 0.7) 0%, rgba(200, 226, 255, 0) 68%);
}

.page-content {
    position: relative;
    z-index: 1;
    padding: 0.3rem 0.4rem 0.48rem;
    box-sizing: border-box;
}

.bgViewStyle ::v-deep .van-nav-bar {
    background: transparent;
}

.bgViewStyle ::v-deep .van-nav-bar::after {
    display: none;
}

.bgViewStyle ::v-deep .van-nav-bar .van-icon {
    color: #2b7de9;
    font-size: 0.4rem;
}

.brand {
    display: flex;
    align-items: center;
    margin-bottom: 0.48rem;
}

.brand-logo {
    width: 0.72rem;
    height: 0.72rem;
    border-radius: 0.16rem;
    flex-shrink: 0;
}

.brand-text {
    margin-left: 0.18rem;
}

.brand-name {
    font-size: 0.36rem;
    font-weight: 700;
    color: #1a5fd0;
    line-height: 1.2;
    letter-spacing: 0.02rem;
}

.brand-slogan {
    margin-top: 0.06rem;
    font-size: 0.2rem;
    color: #3d7fd9;
    letter-spacing: 0.04rem;
    line-height: 1;
}

.hero-title {
    margin: 0 0 0.56rem;
    font-size: 0.56rem;
    font-weight: 700;
    color: #1e3a5f;
    line-height: 1.35;
    letter-spacing: 0.01rem;
}

.login-card {
    background: #ffffff;
    border-radius: 0.32rem;
    padding: 0.4rem 0.36rem 0.4rem;
    box-shadow: 0 0.16rem 0.48rem rgba(40, 100, 180, 0.08);
}

.card-header {
    display: flex;
    align-items: center;
    margin-bottom: 0.4rem;
}

.card-icon {
    width: 0.72rem;
    height: 0.72rem;
    border-radius: 50%;
    background: #e8f2ff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.card-icon svg {
    width: 0.36rem;
    height: 0.36rem;
}

.card-header-text {
    margin-left: 0.2rem;
}

.card-title {
    font-size: 0.32rem;
    font-weight: 600;
    color: #1e3a5f;
    line-height: 1.3;
}

.card-subtitle {
    margin-top: 0.06rem;
    font-size: 0.22rem;
    color: #8a9bb0;
    line-height: 1.3;
}

.form-item {
    margin-bottom: 0.28rem;
}

.form-label {
    display: block;
    margin-bottom: 0.12rem;
    font-size: 0.26rem;
    color: #334155;
    font-weight: 500;
}

.form-input {
    display: block;
    width: 100%;
    height: 0.88rem;
    padding: 0 0.24rem;
    border: 1px solid #dce5f0;
    border-radius: 0.16rem;
    background: #ffffff;
    font-size: 0.28rem;
    color: #1e3a5f;
    outline: none;
    box-sizing: border-box;
    -webkit-appearance: none;
    appearance: none;
}

.form-input::placeholder {
    color: #b0bccb;
}

.form-input:focus {
    border-color: #4a90e2;
}

.code-row {
    display: flex;
    align-items: center;
    gap: 0.16rem;
}

.code-input {
    flex: 1;
    min-width: 0;
}

.code-btn {
    flex-shrink: 0;
    height: 0.88rem;
    padding: 0 0.28rem;
    border: 1px solid #4a90e2;
    border-radius: 0.16rem;
    background: #ffffff;
    color: #2b7de9;
    font-size: 0.26rem;
    white-space: nowrap;
    cursor: pointer;
}

.code-btn:disabled {
    border-color: #c5d3e5;
    color: #9aadc4;
    cursor: not-allowed;
}

.agree-row {
    display: flex;
    align-items: flex-start;
    margin: 0.32rem 0 0.36rem;
    cursor: pointer;
}

.agree-checkbox {
    width: 0.32rem;
    height: 0.32rem;
    margin-top: 0.02rem;
    margin-right: 0.12rem;
    border: 1.5px solid #c5d0de;
    border-radius: 0.06rem;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    background: #fff;
}

.agree-checkbox.checked {
    background: #2b7de9;
    border-color: #2b7de9;
}

.agree-checkbox svg {
    width: 0.2rem;
    height: 0.16rem;
}

.agree-text {
    font-size: 0.24rem;
    color: #64748b;
    line-height: 1.5;
}

.agree-text a {
    color: #2b7de9;
    text-decoration: none;
}

.login-btn {
    display: block;
    width: 100%;
    height: 0.92rem;
    border: none;
    border-radius: 0.16rem;
    background: #2b7de9;
    color: #ffffff;
    font-size: 0.32rem;
    font-weight: 500;
    letter-spacing: 0.04rem;
    cursor: pointer;
}

.login-btn:disabled {
    background: #a8c4e8;
    cursor: not-allowed;
}

.footer-tip {
    margin: 0.4rem 0 0;
    text-align: center;
    font-size: 0.24rem;
    color: #b0bccb;
}
</style>
